<template>
    <div>
        <drop class="cardDrop" :class="{cardDropDragOver: dragging}" drag-over="handleDragOver" @dragenter="dragging=true" @dragend="dragging=false" @dragleave="dragging=false" @drop="doDrop"></drop>
        <drag class="listThumbnail" :transfer-data="{listIndex: listIndex, itemIndex: itemIndex, type: 'list', kind: 'listThumbnail'}">
            <div class="has-text-centered has-background-coolGreen">
                <div class="is-size-6  has-text-white" @click="go(url)">{{listName}}</div>
                <div><i class="fa fa-list has-text-white"></i></div>
            </div>
        </drag>
    </div>

</template>

<script>
import { Drag, Drop } from 'vue-drag-drop'

export default {
    name: 'listThumbnail',
    components: {Drag, Drop},
    props: {
        listName: String,
        listIndex: Number,
        itemIndex: Number
    },
    data: function(){
        return {
            dragging: false,
        }
    },
    methods: {
        moveItem: function(fromList, fromIndex, toList, toIndex){

            let item = {};

            if(fromIndex != undefined){
                //url
                item = this.$root.app.init.lists[fromList].items[fromIndex];
                //insert
                this.$root.app.init.lists[toList].items.splice(toIndex, 0, item);
                //remove
                this.$root.app.init.lists[fromList].items.splice(fromIndex, 1);
            } else {
                //list
                item = this.$root.app.init.lists[fromList];
                //insert
                this.$root.app.init.lists[toList].items.splice(toIndex, 0, item);
                //remove
                this.$root.app.init.lists.splice(fromList, 1);
                 this.dragging = false;
            }
            
            
        },
        doDrop: function(data, event){
            this.moveItem(data.listIndex, data.itemIndex, this.listIndex, this.itemIndex);
        },
        go: function(url){
            alert('Open List - ' + this.listName)
        }
    }
}
</script>